var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"generic-landings@3.2.7"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/webassets/webview-generic-landing/generic-landings/3.2.7";

const Sentry = require('@sentry/nextjs');
const applicationName = require('./config/applicationName');
const applicationVersion = require('./config/applicationVersion');

Sentry.init({
  dsn: 'https://39c562b4b4ddbe190bb5955f3cf9f7c5@o4504046939799552.ingest.us.sentry.io/4507227936849920',
  tracesSampleRate: 0.1,
  sampleRate: 0.1,
  environment:
    window.location.host === 'web-apps.pedidosya.com' ? 'live' : 'stg',
  release: `${applicationName}@${applicationVersion}`,
  integrations: [
    new Sentry.BrowserTracing({
      beforeNavigate: (context) => ({
        ...context,
        name: '/generic-landings',
      }),
    }),
  ],
});
